import { render } from "./QbrBriefView.vue?vue&type=template&id=77b337cd&scoped=true"
import script from "./QbrBriefView.vue?vue&type=script&lang=js"
export * from "./QbrBriefView.vue?vue&type=script&lang=js"

import "./QbrBriefView.vue?vue&type=style&index=0&id=77b337cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b337cd"]])

export default __exports__